// extracted by mini-css-extract-plugin
export default {"capitalize":"AuditorDetailsTab_capitalize__3E9tV","title":"AuditorDetailsTab_title__RUhNf","label":"AuditorDetailsTab_label__MBB-U"};